import { apiRequest } from './api';
import { TokenResponse, UserInfo } from '@/types';
import { STORAGE_KEYS } from '@/constants/storage';

export interface BucketPreferenceResponse {
  selected_buckets: string[];  // Array of "provider:bucket_name"
}

export const authService = {
  // Real login with username and password
  async login(username: string, password: string): Promise<string> {
    // OAuth2 requires FormData with username and password fields
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const response = await apiRequest<TokenResponse>({
      method: 'POST',
      url: '/auth/login',
      data: formData.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const token = response.access_token;
    this.saveToken(token);
    return token;
  },

  // Get current user info
  async getCurrentUser(): Promise<UserInfo> {
    return apiRequest<UserInfo>({
      method: 'GET',
      url: '/auth/me',
    });
  },

  // Save token to localStorage
  saveToken(token: string): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  },

  // Get token from localStorage
  getToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  },

  // Remove token from localStorage
  removeToken(): void {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  },

  // Check if user is authenticated
  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  // Logout (clear token and user data)
  logout(): void {
    this.removeToken();
  },

  // Get user's bucket preferences (multi-select)
  async getBucketPreference(): Promise<BucketPreferenceResponse> {
    return apiRequest<BucketPreferenceResponse>({
      method: 'GET',
      url: '/auth/bucket-preference',
    });
  },

  // Update user's bucket preferences (multi-select)
  async updateBucketPreference(buckets: string[]): Promise<BucketPreferenceResponse> {
    return apiRequest<BucketPreferenceResponse>({
      method: 'PUT',
      url: '/auth/bucket-preference',
      data: { buckets },
    });
  },
};
